import React from 'react';

import Download from '../assets/images/download.svg';
import Look from '../assets/images/eye.svg';
import PdfIcon from '../assets/images/pdf-icon.svg';

export default function LoanFileItem({ name, weight, onDownload, toggleFileOpen }) {
  return (
    <div className="loan-file-item">
      <div className="loan-file-item__image">
        <img src={PdfIcon} alt="file" />
      </div>
      <div className="loan-file-item__params">
        <div className="loan-file-item__params__title">{name}</div>
        <div className="loan-file-item__params__weight">{weight}</div>
      </div>
      <div className="loan-file-item__actions">
        <div className="loan-file-item__actions__look">
          <button onClick={toggleFileOpen}>
            <img src={Look} alt="look" />
          </button>
        </div>
        <div className="loan-file-item__actions__download">
          <button onClick={onDownload}>
            <img src={Download} alt="download" />
          </button>
        </div>
      </div>
    </div>
  );
}
